/**
 * Canonical display order for meta prompt keys (Initial vs Optimized payloads
 * may enumerate keys in different orders — align UI lists for Before & After).
 */
export const META_PROMPT_KEY_ORDER: readonly string[] = [
  'CORE_PROMPT',
  'MASTER_SUFFIX',
  'ASYNC_SUFFIX',
  'SYNC_EXTRA',
  'RAG_PROMPT',
  'FINAL_STEP_PROMPT',
  'LTM_PROMPT',
  'RAG_TOOL_DESCRIPTION',
  'LTM_TOOL_DESCRIPTION',
  'MODERATION_PROMPT',
  'DIARY_WRITE_PROMPT',
  'DIARY_READ_PROMPT',
  'PORTRAIT_READ_PROMPT',
  'PORTRAIT_WRITE_PROMPT',
];

export function sortMetaPromptKeys(keys: readonly string[]): string[] {
  const orderMap = new Map(META_PROMPT_KEY_ORDER.map((k, i) => [k, i]));
  const unknownBase = META_PROMPT_KEY_ORDER.length;
  return [...keys].sort((a, b) => {
    const ia = orderMap.has(a) ? orderMap.get(a)! : unknownBase;
    const ib = orderMap.has(b) ? orderMap.get(b)! : unknownBase;
    if (ia !== ib) return ia - ib;
    return a.localeCompare(b);
  });
}
